export const INITIAL_VALUE = {
    onClickOption: () => {},
};
